export type FactSection = 'prescribers' | 'prescribing' | 'agreements' | 'practice';

export interface FactTarget {
  kind: 'person' | 'state' | 'medication' | 'care_process';
  personId?: string;
  state?: string;
  medication?: string;
  field?: string;
  itemId?: string;
}

export function targetSection(path: string | null | undefined): FactSection | null {
  if (!path) return null;
  if (path.startsWith('provider.collaboration_agreements') || path.startsWith('provider.pa_crnp_agreements') || path.startsWith('provider.ky_capa_') || path.startsWith('provider.wi_aprn_transitions') || path.startsWith('provider.az_pa_ii_iii_approvals') || path.startsWith('provider.al_schedule_ii_lpsps') || path.startsWith('provider.la_aprn_site_cs_scopes') || path.startsWith('provider.md_aprn_role_scopes') || path.startsWith('provider.nm_non_cnp_formularies') || path.startsWith('provider.or_crna_outpatient_scopes') || path.startsWith('provider.supervising_provider')) return 'agreements';
  if (path.startsWith('provider.') || path.startsWith('compacts.')) return 'prescribers';
  if (path.startsWith('tenant.drug_scope') || path.startsWith('tenant.declared_scope')) return 'prescribing';
  if (path.startsWith('tenant.') || path.startsWith('practice_addresses')) return 'practice';
  return null;
}

export function factTarget(path: string, personId?: string, state?: string, medication?: string): FactTarget {
  if (path.startsWith('tenant.drug_scope') || path.startsWith('tenant.declared_scope') || path.startsWith('provider.collaboration_agreements'))
    return { kind: 'medication', personId, state, medication, field: path };
  if (path.startsWith('tenant.operating_states') || path.startsWith('practice_addresses'))
    return { kind: 'state', state, field: path };
  if (path.startsWith('tenant.')) return { kind: 'care_process', field: path };
  return { kind: 'person', personId, state, medication, field: path };
}

export function parseFactTarget(value: string | null): FactTarget | null {
  if (!value || value.length > 1000) return null;
  try {
    const parsed: unknown = JSON.parse(value);
    if (!parsed || typeof parsed !== 'object') return null;
    const t = parsed as Record<string, unknown>;
    if (!['person', 'state', 'medication', 'care_process'].includes(String(t.kind))) return null;
    for (const field of ['personId', 'state', 'medication', 'field']) if (t[field] !== undefined && (typeof t[field] !== 'string' || (t[field] as string).length > 160)) return null;
    if (t.itemId !== undefined && (typeof t.itemId !== 'string' || !/^[0-9a-f]{24}$/.test(t.itemId))) return null;
    return t as unknown as FactTarget;
  } catch { return null; }
}
